import config from 'src/config';

function AppConfig($compileProvider, tablelistSdkProvider, sdkConfigProvider) {
  // Angular debugging
  // https://docs.angularjs.org/guide/production
  $compileProvider.debugInfoEnabled(config.NODE_ENV !== 'production');

  tablelistSdkProvider.setEnv(config.NODE_ENV);
  tablelistSdkProvider.setSubclient('affiliate');
  tablelistSdkProvider.setUseAuthHeader(true);

  sdkConfigProvider
    .setApiBaseUrl(config.SDK_API_URL)
    .setEnableDebugMode(config.NODE_ENV !== 'production')
    // .setEnableSecureCookie(false)
    // .setEnableCookieDomain(false)
    .setEnableSecureCookie(config.NODE_ENV === 'production')
    .setEnableCookieDomain(config.NODE_ENV === 'production')
    .setClient('web')
    .setGetUserOnStartUp(true);

  if (config.NODE_ENV !== 'production') {
    sdkConfigProvider.setCookiePrefix('dev');
  }
}

AppConfig.$inject = [
  '$compileProvider',
  'TablelistSdkProvider',
  'jsSdk.configProvider'
];

export default AppConfig;



// WEBPACK FOOTER //
// ./src/appConfig.js